module.exports = __webpack_public_path__ + "img/wenn-die-familie-zerbricht.64619603.jpg";